import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import AuthLayout from "./layouts/AuthLayout";

import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads/Leads";
import Vendor from "./pages/DatabaseVendor/Vendor";
import DatabaseLeads from "./pages/DatabaseLeads/Leads/Index";
import UserList from "./pages/users/UserList";
import Login from "./pages/Login";
import Tutorial from "./pages/Tutorial/Index";
import ChangePassword from "./pages/Profile/ChangePassword";
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Halaman tanpa sidebar */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Login />} />
        </Route>

        {/* Halaman dengan sidebar */}
        <Route element={<AppLayout />}>
          <Route path="/users" element={<UserList />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/databaseLeads" element={<DatabaseLeads />} />
          <Route path="/databaseVendor" element={<Vendor />} />
          <Route path="/tutorial" element={<Tutorial />} />
          <Route path="/profile/changepassword" element={<ChangePassword />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
